export enum ItemRarity {
  Common = 1,
  Rare = 2,
  Expensive = 3,
  Magnificent = 4,
  VIP = 5,
}
